import { rand, randNumber, randCatchPhrase } from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { Calculator } from '../base';
import { DimsUom, WeightsUom } from '../units-of-measure';

export class MockCalculator extends Calculator {
   constructor() {
      super({
         pieces: randNumber({ max: 100 }),
         weight: randNumber({ max: 10000 }),
         weight_type: rand([ ...WeightsUom ]),
         length: randNumber({ max: 100 }),
         width: randNumber({ max: 100 }),
         height: randNumber({ max: 100 }),
         measure_type: rand([ ...DimsUom ]),
      });

      if ( optional() ) { this.description = randCatchPhrase(); }
      if ( optional() ) { this.reference = randCatchPhrase(); }
   }
}
